<template>
    <div class="grow pointer mr3">
        <a><img :src="image"/></a>
    </div>
</template>

<script>
export default {
    props: {
        image: {
            type: String
        }
    }
};
</script>
